import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const LabelledTextBox = ({ label, type, value, name, onChange, onBlur }) => {
  const [showPassword, setShowPassword] = useState(false);

  const onTextChange = (e) => {
    onChange({
      ...e,
      value: e.target.value,
      name: e.target.name,
      type: e.target.type,
    });
  };

  const onTextBlur = (e) => {
    onBlur({
      ...e,
      value: e.target.value,
      name: e.target.name,
      type: e.target.type,
    });
  };

  const toggleShowPassword = () => {
    if (type === 'password') {
      setShowPassword(!showPassword);
    }
  };

  const inputType = type === 'password' && showPassword ? 'text' : type;

  return (
    <div className="labelled-text-box">
      <span className="label">{label}</span>
      <input type={inputType ? inputType : 'text'} value={value?.toString() ?? ''}
        name={name}
        onChange={onTextChange}
        onBlur={onTextBlur}
        placeholder={label}
      />
      {type === 'password' && (<div className="show-password">
        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} onClick={toggleShowPassword} />
      </div>)}
    </div>
  );
};

export default LabelledTextBox;
